
const TYPES = {
    //EXAMPLE DI
    IRoute : Symbol.for("IRoute"),
    IAppConfig : Symbol.for("IAppConfig"),
    IUserClient: Symbol.for("IUserClient"),
    IDossierClient: Symbol.for("IDossierClient"),
};

export { TYPES };